import { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { ADMIN_EXTRA as T } from "@/constants/testIds";

const shortDate = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" });

const Lift = ({ s }) => (
  <p data-testid={T.bundleStatsLift} className="text-sm text-stone-600">
    {s.lift === null
      ? "Once you have orders with and without bundles, you'll see how much more bundle shoppers spend."
      : <>Bundle orders average <strong>{money(s.avg_with)}</strong> vs {money(s.avg_without)} without: <strong className={s.lift >= 0 ? "text-[#4E7B68]" : "text-amber-700"}>{s.lift >= 0 ? "+" : "−"}{money(Math.abs(s.lift))}</strong> per order.</>}
  </p>
);

const Weeks = ({ weeks }) => {
  const max = Math.max(...weeks.map((w) => w.sets), 1);
  return (
    <div className="flex items-end gap-2 h-28">
      {weeks.map((w) => (
        <div key={w.week_start} data-testid={T.bundleStatsWeek(w.week_start)} title={`Week of ${w.week_start}: ${w.sets} sold, ${money(w.savings)} saved`} className="flex-1 flex flex-col items-center gap-1 h-full justify-end">
          <span className="text-[10px] text-stone-500">{w.sets || ""}</span>
          <div className="w-full rounded-t-md bg-[#4E7B68] transition-[height] duration-500" style={{ height: `${Math.max((w.sets / max) * 100, w.sets ? 6 : 2)}%`, opacity: w.sets ? 1 : 0.25 }} />
          <span className="text-[10px] text-stone-400 whitespace-nowrap">{shortDate(w.week_start)}</span>
        </div>
      ))}
    </div>
  );
};

export const AdminBundleStats = ({ refreshKey }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/bundle-stats", { params: { weeks: 8 } }).then(({ data }) => setS(data)).catch(() => setS(false)); }, [refreshKey]);
  if (!s) return null;
  return (
    <div data-testid={T.bundleStats} className="bg-white border border-[#F0EBE1] rounded-[1.5rem] p-5 space-y-4">
      <div className="flex flex-wrap justify-between gap-2">
        <p className="font-heading font-bold">Kiddee bundles, last 8 weeks</p>
        <p className="text-sm text-stone-600">{s.sets} sold in {s.orders} order{s.orders === 1 ? "" : "s"} · {money(s.savings)} saved by shoppers</p>
      </div>
      <Weeks weeks={s.weeks} />
      <Lift s={s} />
      {s.by_bundle.length > 0 && (
        <ol className="space-y-1.5 text-sm">
          {s.by_bundle.map((b) => (
            <li key={b.slug} data-testid={T.bundleStatsRow(b.slug)} className="flex justify-between gap-3"><span>{b.name}</span><span className="text-stone-500 whitespace-nowrap">{b.sets} sold · {money(b.savings)} saved</span></li>
          ))}
        </ol>
      )}
    </div>
  );
};
